import { Component } from '@angular/core';

import { BooleanAdvancedFilterModel, ICellEditorParams, JoinAdvancedFilterModel } from 'ag-grid-enterprise';

import { CheckboxComponent } from '@camelot/form-input';

import { BaseEditorComponent } from '../base-col';
import type { BoolCol } from './bool-col';

@Component({
  host: { 'data-cid': 'bool-editor' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [CheckboxComponent],
  template: ` @if (this.input) {
    <div class="p-space-sm">
      <cam-input-checkbox [input]="$any(this.input)" [standalone]="true" [onFocus]="this.focus$"></cam-input-checkbox>
    </div>
  }`,
})
export class BoolEditorComponent extends BaseEditorComponent<
  JoinAdvancedFilterModel | BooleanAdvancedFilterModel,
  BoolCol
> {
  override agInit(params: ICellEditorParams) {
    super.agInit(params);
  }

  getValue() {
    return this.input?.value ?? null;
  }
}
